import { map } from 'rxjs/operators'
import { ofType, StateObservable, ActionsObservable } from 'redux-observable'
import { syncUiType } from '../../actions/docs/syncUi'
import { State, ReduxAction } from '../../reducers/reducerType'
import { updateQuestionsArray } from '../../actions/questions/questions'

export const updateQuestions$ = (actions$: ActionsObservable<ReduxAction>, state$: StateObservable<State>) => actions$.pipe(
  ofType(syncUiType.SET_SYNC_QUESTIONS),
  map(() => updateQuestionsArray(state$.value.syncUi.questions))
)

export default updateQuestions$
